import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HasAccessView from '../../guard/has-access-view';
import { PROFILES } from '../../constants';
import Icon from '../../components/forms/icon.component';

function Aside() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      <div
        id="kt_aside"
        className="aside aside-default aside-hoverable"
        data-kt-drawer="true"
        data-kt-drawer-name="aside"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="{default:'200px', '300px': '250px'}"
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_aside_toggle"
      >
        <div className="aside-logo flex-column-auto px-10 pt-9 pb-5" id="kt_aside_logo">
          <Link to="/dashboard">
            <img
              alt="Logo"
              src="/assets/media/logos/ch-l.svg"
              className="max-h-60px w-100px logo-default theme-light-show"
              width={'100px'}
              height={'60px'}
            />
            <img
              alt="Logo"
              src="/assets/media/logos/ch-l-dark.svg"
              className="max-h-60px w-100px logo-default theme-dark-show"
              width={'100px'}
              height={'60px'}
            />
            <img
              alt="Logo"
              src="/assets/media/logos/logo-c.svg"
              className="w-65px logo-minimize"
              width={'65px'}
              height={'60px'}
            />
          </Link>
        </div>
        <div className="aside-menu flex-column-fluid ps-3 pe-1">
          <div
            className="menu menu-sub-indention menu-column menu-rounded menu-title-gray-600 menu-icon-gray-500 menu-active-bg menu-state-primary menu-arrow-gray-500 fw-semibold fs-6 my-5 mt-lg-2 mb-lg-0"
            id="kt_aside_menu"
            data-kt-menu="true"
          >
            <div
              className="hover-scroll-y mx-4"
              id="kt_aside_menu_wrapper"
              data-kt-scroll="true"
              data-kt-scroll-activate="{default: false, lg: true}"
              data-kt-scroll-height="auto"
              data-kt-scroll-wrappers="#kt_aside_menu"
              data-kt-scroll-offset="20px"
              data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
            >
              {/* <div className="menu-item">
                <Link
                  className={`menu-link ` + (location.pathname === '/dashboard' ? 'active' : '')}
                  to="/dashboard"
                >
                  <span className="menu-icon">
                    <Icon icon="ki-abstract-25" size="fs-2x" />
                  </span>
                  <span className="menu-title">{t('asaid.link-dashboard')}</span>
                </Link>
              </div> */}
              {/* <div className="menu-item pt-5">
                <div className="menu-content">
                  <span className="fw-bold text-muted text-uppercase fs-7">
                    {t('campaigns.campaigns-title')}
                  </span>
                </div>
              </div>
              */}
              <div className="menu-item pt-5">
                <div className="menu-content">
                  <span className="fw-bolder text-muted text-uppercase fs-7">
                    {t('campaigns.campaigns-title')}
                  </span>
                </div>
              </div>
              <HasAccessView view={[PROFILES.ROOT, PROFILES.ADMIN, PROFILES.STANDARD_USER]}>
                <div className="menu-item hover-scale">
                  <Link
                    className={
                      `menu-link ` +
                      (location.pathname === '/sendCampaigns' ||
                      location.pathname === '/sendCampaigns/standard-campaigns' ||
                      location.pathname === '/sendCampaigns/fallback-campaigns' ||
                      location.pathname === '/sendCampaigns/flows-campaigns' ||
                      location.pathname === '/sendCampaigns/flows-campaigns/builder' ||
                      location.pathname === '/'
                        ? 'active'
                        : '')
                    }
                    to="/sendCampaigns"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-send" size="fs-2" className="text-dark hover-icon" />
                    </span>
                    <span className="menu-title">{t('campaigns.send-campaigns')}</span>
                  </Link>
                </div>
              </HasAccessView>
              {/* <HasAccessView view={[PROFILES.ROOT, PROFILES.ADMIN, PROFILES.STANDARD_USER]}>
                <div className="menu-item hover-scale">
                  <Link
                    className={
                      `menu-link ` +
                      (location.pathname === '/sendCampaigns/flows-answers' ||
                      location.pathname === '/sendCampaigns/flows-answers/builder'
                        ? 'active'
                        : '')
                    }
                    to="/sendCampaigns/flows-answers"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-data" size="fs-2" className="text-dark hover-icon" />
                    </span>
                    <span className="menu-title">Flujos respuesta</span>
                  </Link>
                </div>
              </HasAccessView> */}
              <div className="menu-item pt-5">
                <div className="menu-content">
                  <span className="fw-bolder text-muted text-uppercase fs-7">
                    {t('asaid.link-users')}
                  </span>
                </div>
              </div>
              <HasAccessView view={[PROFILES.ROOT, PROFILES.ADMIN, PROFILES.STANDARD_USER]}>
                <div className="menu-item hover-scale">
                  <Link
                    className={`menu-link ` + (location.pathname === '/users' ? 'active' : '')}
                    to="/users"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-profile-user" size="fs-1" className="text-dark hover-icon" />
                    </span>
                    <span className="menu-title">{t('asaid.link-users')}</span>
                  </Link>
                </div>
              </HasAccessView>
              <HasAccessView view={[PROFILES.ROOT, PROFILES.ADMIN, PROFILES.STANDARD_USER]}>
                <div className="menu-item hover-scale">
                  <Link
                    className={
                      `menu-link ` +
                      (location.pathname === '/roles' || location.pathname === '/roles/builder-role'
                        ? 'active'
                        : '')
                    }
                    to="/roles"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-check-square" size="fs-1" className="text-dark hover-icon" />
                    </span>
                    <span className="menu-title">{t('asaid.link-roles')}</span>
                  </Link>
                </div>
              </HasAccessView>
              <HasAccessView view={[PROFILES.ROOT, PROFILES.ADMIN, PROFILES.STANDARD_USER]}>
                <div className="menu-item pt-5">
                  <div className="menu-content">
                    <span className="fw-bolder text-muted text-uppercase fs-7">
                      {t('tools.tools-title')}
                    </span>
                  </div>
                </div>
                <div className="menu-item hover-scale">
                  <Link
                    className={
                      `menu-link ` +
                      (location.pathname === '/templates-panel' ||
                      location.pathname === '/templates-panel/templates-rcs' ||
                      location.pathname === '/templates-panel/templates-rcs-builder' ||
                      location.pathname === '/templates-panel/templates-rcs-builder-basic' ||
                      location.pathname === '/templates-panel/templates-rcs-builder-single' ||
                      location.pathname ===
                        '/templates-panel/templates-rcs-builder-conversational' ||
                      location.pathname === '/templates-panel/templates-wa' ||
                      location.pathname === '/templates-panel/templates-wa-builder' ||
                      location.pathname === '/templates/create-template-WA' ||
                      location.pathname === '/templates-panel/accounts-wa' ||
                      location.pathname === '/templates-panel/templates-mailing' ||
                      location.pathname === '/templates-panel/templates-mailing-builder'
                        ? 'active'
                        : '')
                    }
                    to="/templates-panel"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-picture" size="fs-1" className="text-dark hover-icon" />
                    </span>
                    <span className="menu-title">{t('templates.templates-title')}</span>
                  </Link>
                </div>
                <div className="menu-item hover-scale">
                  <Link
                    className={
                      `menu-link ` +
                      (location.pathname === '/blacklist' ||
                      location.pathname === '/blacklist/add-blacklist' ||
                      location.pathname === '/blacklist/edit-blacklist'
                        ? 'active'
                        : '')
                    }
                    to="/blacklist"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-shield" size="fs-1" className="text-dark hover-icon" />
                    </span>
                    <span className="menu-title">{t('asaid.link-blacklist')}</span>
                  </Link>
                </div>
              </HasAccessView>

              <div className="menu-item pt-5">
                <div className="menu-content">
                  <span className="fw-bolder text-muted text-uppercase fs-7">Configuración</span>
                </div>
              </div>
              <div
                className="menu-item"
                data-kt-menu-placement="right-start"
                data-kt-menu-trigger="hover"
              >
                <a
                  className={
                    `menu-link ` +
                    (location.pathname === '/accounts' ||
                    location.pathname === '/accounts/add' ||
                    location.pathname === '/accounts/channels-configurator' ||
                    location.pathname.startsWith('/accounts/channels-configurator/') ||
                    location.pathname === '/channels-panel' ||
                    location.pathname === '/channels-panel/channels-wa' ||
                    location.pathname === '/channels-panel/channels-rcs' ||
                    location.pathname === '/channels-panel/channels-sms' ||
                    location.pathname === '/channels-panel/channels-mailing' ||
                    location.pathname === '/pnn-portability'
                      ? 'active'
                      : '')
                  }
                  href="#"
                >
                  <span className="menu-icon">
                    <Icon icon="ki-abstract-24" size="fs-2x" className="text-dark hover-icon" />
                  </span>
                  <span className="menu-title">{t('asaid.link-title-operations')}</span>
                  <span className="menu-arrow" />
                </a>
                <div className="menu-sub menu-sub-dropdown p-3 w-220px ms-5">
                  <HasAccessView view={[PROFILES.ROOT]}>
                    <div className="menu-item hover-scale">
                      <Link
                        className={
                          `menu-link ` +
                          (location.pathname === '/accounts' ||
                          location.pathname === '/accounts/add' ||
                          location.pathname === '/accounts/channels-configurator' ||
                          location.pathname.startsWith('/accounts/channels-configurator/')
                            ? 'active'
                            : '')
                        }
                        to="/accounts"
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">{t('asaid.link-accounts')}</span>
                      </Link>
                    </div>
                  </HasAccessView>
                  <div className="menu-item hover-scale">
                    <Link
                      className={
                        `menu-link ` +
                        (location.pathname === '/channels-panel' ||
                        location.pathname === '/channels-panel/channels-wa' ||
                        location.pathname === '/channels-panel/channels-rcs' ||
                        location.pathname === '/channels-panel/channels-sms' ||
                        location.pathname === '/channels-panel/channels-mailing'
                          ? 'active'
                          : '')
                      }
                      to="/channels-panel"
                    >
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">{t('asaid.link-menu-channels')}</span>
                    </Link>
                  </div>
                  <HasAccessView view={[PROFILES.ROOT]}>
                    <div className="menu-item hover-scale">
                      <Link
                        className={
                          `menu-link ` + (location.pathname === '/pnn-portability' ? 'active' : '')
                        }
                        to="/pnn-portability"
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">{t('asaid.link-pnn')}</span>
                      </Link>
                    </div>
                  </HasAccessView>
                </div>
              </div>

              {/* <div className="menu-item">
                  <Link
                    className={
                      `menu-link pulse pulse-primary ` +
                      (location.pathname === '/campaigns/monitoring' ||
                      location.pathname === '/campaigns/live-monitoring'
                        ? 'active'
                        : '')
                    }
                    to="/campaigns/monitoring"
                  >
                    <span className="menu-icon">
                      <Icon icon="ki-abstract-27" size="fs-2x" />
                      <span className="pulse-ring border-4"></span>
                    </span>
                    <span className="menu-title">{t('asaid.link-monitoring')} Queue</span>
                  </Link>
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Aside;
